<mat-table #table class="iaud-table" *ngIf="dataSource" [dataSource]="dataSource">
  <ng-container *ngFor="let column of options.columns; let first = first; let last = last;"
                [matColumnDef]="column.fieldName">
    <mat-header-cell class="iaud-table__header-cell" *matHeaderCellDef>{{ column.title }}</mat-header-cell>
    <mat-cell class="iaud-table__cell"
              *matCellDef="let element; let row">

      <div *ngIf="first && options.actionButtons && !options.hideEditButton && !options.hideDeleteButton" class="iaud-table__cell__actions" [class.always-show]="options.alwaysShowButton">
        <div class="iaud-table__cell__actions--edit mat-elevation-z4" [routerLink]="[options.hrefBase, element.id]" *ngIf="options.hrefBase">
          <mat-icon>edit</mat-icon>
        </div>
        <div class="iaud-table__cell__actions--edit mat-elevation-z4" (click)="editData(element.id, element)" *ngIf="!options.hrefBase">
            <mat-icon>edit</mat-icon>
        </div>
        <div class="iaud-table__cell__actions--delete mat-elevation-z4" (click)="deleteData(element.id, element)" *ngIf="deleteData">
          <mat-icon>delete</mat-icon>
        </div>
      </div>
      <div *ngIf="first && options.actionButtons && !options.hideEditButton && options.hideDeleteButton" class="iaud-table__cell__actions">
          <div class="iaud-table__cell__actions--edit-only mat-elevation-z4" [routerLink]="[options.hrefBase, element.id]" *ngIf="options.hrefBase">
            <mat-icon>edit</mat-icon>
          </div>
          <div class="iaud-table__cell__actions--edit-only mat-elevation-z4" (click)="editData(element.id, element)" *ngIf="!options.hrefBase">
              <mat-icon>edit</mat-icon>
          </div>
        </div>
        <div *ngIf="first && options.actionButtons && options.hideEditButton && !options.hideDeleteButton" class="iaud-table__cell__actions">
        <div class="iaud-table__cell__actions--delete-only mat-elevation-z4" (click)="deleteData(element.id, element)" *ngIf="deleteData">
          <mat-icon>delete</mat-icon>
        </div>
      </div>
  
      <span *ngIf="!isNewRow(row) && column.customTemplate">

        <ng-template [ngTemplateOutlet]="column.customTemplate"
                     [ngTemplateOutletContext]="{rowData: element}">
        </ng-template>
      </span>

      <span *ngIf="!isNewRow(row) && !column.customTemplate">
        {{ column.pipe
        ? getPipedValue(element[column.fieldName], column.pipe, column.pipeParams)
        : element[column.fieldName] }}
      </span>

      <span *ngIf="isNewRow(row)">
          <ng-template [ngTemplateOutlet]="column.insertTemplate"
            [ngTemplateOutletContext]="{rowData: element}">
          </ng-template>
      </span>
  
  
      <div *ngIf="last && options.additionalInfo" class="iaud-table__cell__expand" (click)="toggleExpandRow(element)">
        <mat-icon *ngIf="expandedElement === element.id; else expandMore">
          expand_less
        </mat-icon>

        <ng-template #expandMore>
          <mat-icon>expand_more</mat-icon>
        </ng-template>
      </div>

    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="expandedDetail">
    <mat-header-cell *matHeaderCellDef></mat-header-cell>
    <mat-cell class="iaud-table__detail-cell" *matCellDef="let element">
      <div *ngFor="let detail of options.additionalInfo" class="iaud-value-container">

        <span *ngIf="!!detail.customTemplate; else simpleDetail">
          <ng-template [ngTemplateOutlet]="detail.customTemplate"
                       [ngTemplateOutletContext]="{detailData: element, detailOption: detail}">
          </ng-template>
        </span>

        <ng-template #simpleDetail>
          <label [for]="detail.fieldName">{{detail.title}}</label>
          <p [id]="detail.fieldName">{{ element.item[detail.fieldName] }}</p>
        </ng-template>
      </div>
    </mat-cell>
  </ng-container>

  <mat-header-row class="iaud-table__header-row" *matHeaderRowDef="columnFieldNames"></mat-header-row>

  <mat-row *matRowDef="let row; columns: columnFieldNames"
           class="iaud-table__row"
           [class.on-hover]="options.showActionOnHover && !isNewRow(row)"
           [class.single-button]="options.hideDeleteButton || options.hideEditButton"
           [class.expanded]="expandedElement === row.id"
           [class.mat-elevation-z4]="expandedElement === row.id">
  </mat-row>
  <mat-row *matRowDef="let row; columns: ['expandedDetail']; when: isExpansionDetailRow"
           class="iaud-table__details-row"
           [@detailExpand]="row.item.id === expandedElement ? 'expanded' : 'collapsed'">
  </mat-row>
</mat-table>
<mat-paginator class="iaud-table--paginator" *ngIf="usePaginator"
               [pageSizeOptions]="[10, 20, 50, 100]"
               [pageSize]="10"
               [pageIndex]="data.page"
               [length]="data.totalCount"
               (page)="onPageChange($event)">
</mat-paginator>
